import { ILead } from './lead.dto';

export class ITask {
  organization: string;
  _id?: string;
  status: TaskStatus;
  type: string;
  owner: string;
  relatedToLead: string | ILead;
  // relatedToContact: string | IContact;
  description: string;
  notes: string;
  tags: string[];
  createdAt?: string;
  updatedAt?: string;
  isAdminOnly?: boolean;
}

export type TaskStatus =
  | 'completed'
  | 'inprogress'
  | 'new'
  | 'cancelled'
  | 'pending';

import {
  IsNotEmpty,
  IsString,
  IsOptional,
  IsObject,
  IsArray,
  IsBoolean
} from 'class-validator';
import { IBaseResponse } from './base-response.dto';

/* -------------------------------------------------------------------------- */
/*                               Create new Task                              */
/* -------------------------------------------------------------------------- */

export class CreateTaskDto {
  @IsNotEmpty()
  @IsString()
  type: string;

  @IsString()
  @IsOptional()
  owner?: string;

  @IsString()
  @IsOptional()
  relatedToLead?: string | ILead;

  // relatedToContact?: string | IContact;

  @IsString()
  @IsOptional()
  status?: TaskStatus;

  @IsString()
  @IsOptional()
  description: string;

  @IsString()
  @IsOptional()
  notes: string;

  @IsObject()
  @IsOptional()
  extras?: any;

  @IsArray()
  @IsOptional()
  tags?: string[];

  @IsString()
  @IsOptional()
  organization?: string;

  @IsBoolean()
  @IsOptional()
  isAdminOnly?: boolean;
}

/* -------------------------------------------------------------------------- */
/*                                   Update Task                              */
/* -------------------------------------------------------------------------- */

export class UpdateTaskDto {
  @IsNotEmpty()
  @IsString()
  type: TaskStatus;

  @IsString()
  @IsOptional()
  owner: string;

  @IsString()
  @IsOptional()
  relatedToLead?: string | ILead;

  @IsString()
  @IsOptional()
  status: string;

  @IsString()
  @IsOptional()
  description: string;

  @IsString()
  @IsOptional()
  notes: string;

  @IsArray()
  @IsOptional()
  tags?: string[];

  @IsBoolean()
  @IsOptional()
  isAdminOnly?: boolean;
}

export class UpdateTaskResponse extends IBaseResponse {
  id: string;
}

/* -------------------------------------------------------------------------- */
/*                                  Get Tasks                                 */
/* -------------------------------------------------------------------------- */
export class GetTasksDto {
  showClosed?: string;
  type?: string;
  owner?: string;
  status?: string;
  description?: string;
  relatedToLead?: string;
  organization?: string;
  tags?: string; // comma separated string array
  createdAt?: string;
  updatedAt?: string;
  isAdminOnly?: boolean;
  limit?: number;
  offset?: number;
  /** @deprecated use relatedToLead instead */
  relatedTo?: string;
  groups?: string[];
}

export class PatientGetTasksDto {
  showClosed?: string;
  type?: string;
  owner?: string;
  status?: string;
  description?: string;
  tags?: string; // comma separated string array
  createdAt?: string;
  updatedAt?: string;
}

export type GetTasksResponse = ITask[];
